import React, { ReactNode } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

interface GlobalDndProps {
  children: ReactNode;
}

export const GlobalDnd: React.FC<GlobalDndProps> = ({ children }) => {
  return <DragDropContext onDragEnd={() => undefined}>{children}</DragDropContext>;
};
